import { useEffect, useState } from "react";
import BTDialogBox from "../../components/BTDialgBox";
import BTLoader from "../../components/BTLoader";
import BTButton from "../../components/BTButton";
import EnhancedTable from "../../components/BTTable";
import { useLoading } from "../../context";
import Varificationsummary from "./Varificationsummary";
const Summary = ({ summary, setSummary, sizes, setRefresh }) => {
  const { bill_data, returns_data, parties, todayRate } = summary;
  const { showLoading, hideLoading } = useLoading();
  const [varificationSummary, setVarificationSummary] = useState(null);
  const [returnsData, setReturnsData] = useState(returns_data);
  const handleClose = () => {
    setSummary(null);
  };
  const ExpandComponent = ({ row }) => {
    const columns = [
      {
        id: "id",
        name: "ID",
        selector: (row, index) => index + 1,
        width: "50px",
      },
      { id: "service", name: "service", selector: (row) => row.ser_name },
      {
        id: "size",
        name: "size",
        selector: (row) => {
          if (!row.size_id) return "-";
          else {
            const size = sizes?.data?.find(
              ({ size_id }) => size_id === row?.size_id
            );
            return `${size?.size_from} - ${size?.size_to}`;
          }
        },
      },
      { id: "pcs", name: "Pcs", selector: (row) => row.bill_pcs },
      {
        id: "weight",
        name: "Weight",
        selector: (row) => row.bill_cts.toFixed(2),
      },
      {
        id: "rate",
        name: "Rate",
        selector: (row) => Number(row?.bill_rate).toFixed(2),
      },
      {
        id: "amount",
        name: "Amount",
        selector: (row) => row?.bill_amount?.toFixed(2),
      },
      {
        id: "total",
        name: "Total",
        selector: (row) => row?.bill_total?.toFixed(2),
      },
    ];

    return (
      <EnhancedTable
        rows={row?.sub_billing_lines}
        columns={columns}
        tableHeader={false}
        title="Labout Details"
      />
    );
  };

  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "party",
      name: "Party",
      selector: (row) =>
        parties?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
    },
    {
      id: "total",
      name: "Total",
      selector: (row) => row.bill_total.toFixed(2),
    },
    {
      id: "actions",
      name: "Actions",
      width: "200px",
      center: true,
      selector: (row) => {
        const party_wise_returns = returnsData?.filter(
          (item) => item?.p_id === row?.p_id
        );
        return (
          <BTButton
            size="small"
            color="dark"
            disabled={party_wise_returns?.some(
              (item) => item?.ret_bill_status === 2
            )}
            loadingPosition="start"
            variant="gradient"
            onClick={async () => {
              setVarificationSummary({
                row,
                returns_data: party_wise_returns,
              });
            }}
          >
            generate bill
          </BTButton>
        );
      },
    },
  ];

  return (
    <BTDialogBox
      open={Boolean(bill_data)}
      fullWidth
      maxWidth={"xl"}
      maxHeight={"600px"}
      minHeight={"600px"}
      close={handleClose}
      title={"Summary"}
    >
      <BTLoader />
      <EnhancedTable
        rows={bill_data}
        columns={columns}
        tableHeader={false}
        expandComponent={<ExpandComponent />}
        expandRow={true}
        title="Labout Details"
      />
      {Boolean(varificationSummary) && (
        <Varificationsummary
          varificationSummary={varificationSummary}
          setVarificationSummary={setVarificationSummary}
          todayRate={todayRate}
          setReturnsData={setReturnsData}
          sizes={sizes}
        />
      )}
    </BTDialogBox>
  );
};

export default Summary;
